import { Phone } from 'lucide-react';
import { Input } from '@/components/ui/input';

export function GuestPhoneField({ value, onChange }) {
  return (
    <div className="mb-4" data-testid="guest-phone-field">
      <label className="text-sm font-medium text-[#1C1917] dark:text-white flex items-center gap-1.5 mb-1.5">
        <Phone className="w-4 h-4 text-[#264639]" /> Teléfono de contacto <span className="text-[#C36F4D]">*</span>
      </label>
      <Input type="tel" inputMode="tel" value={value || ''} onChange={(e) => onChange(e.target.value)}
        placeholder="+595 981 123 456" autoComplete="tel" data-testid="guest-phone-input" />
      <p className="text-xs text-[#78716C] mt-1">Con código de país. Lo usamos para coordinar tu llegada por WhatsApp.</p>
    </div>
  );
}
